module.exports = __webpack_public_path__ + "static/media/stationScreen.eab09853.png";